import Typography from '@mui/material/Typography'
import { FC, ReactNode } from 'react'

type Props = {
    price: ReactNode
    isInfinity: boolean
    discountedPrice?: number
    color?: string
}

export const PriceInfo: FC<Props> = ({ price, isMobile }) => (
    <Typography
        variant="h2"
        sx={{ fontSize: isMobile ? '24px' : '40px', fontWeight: 600, color: '#000' }}>
        {price} ₽{' '}
    </Typography>
)
